<template>
  <div>
    <div class="bg-primary-1 ">
      <div class="grid lg:grid-cols-2 pl-0 container lg:max-w-7xl">
      </div>
    </div>
    <div class="bg-gray-2">
      <div
        class="container lg:py-12 lg:max-w-7xl place-items-start grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
      >
        <div class="grid">
          <Heading variant="h3">Connect With Us</Heading>
          <ul class="pl-0 grid grid-cols-1 gap-2 mt-4">
            <li v-for="(socialLink, s) in socialLinks" :key="s">
              <a :href="socialLink.href" target="_blank" class="text-links-1 flex align-center space-between gap-2">
                <component :is="socialLink.icon" />
                {{ socialLink.service }}
              </a>
            </li>
          </ul>
        </div>
        <div class="grid">
          <Heading variant="h3">Quick Links</Heading>
          <ul class="pl-0 grid grid-cols-1 gap-2 mt-4">
            <li v-for="(quickLink, q) in quickLinks" :key="q">
              <a :href="quickLink.href" target="_blank" class="text-links-1">
                {{ quickLink.text }}
              </a>
            </li>
          </ul>
        </div>
        <div class="grid">
          <Heading variant="h3">Company</Heading>
          <ul class="pl-0 grid grid-cols-1 gap-2 mt-4">
            <li v-for="(companyItem, q) in company" :key="q">
              <a :href="companyItem.href" target="_blank" class="text-links-1">
                {{ companyItem.text }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="place-items-start grid text-sm text-white bg-gray-3">
      <p class="container lg:max-w-7xl">
        Copyright ©2023 BlueChipCar. All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
import Heading from "./Heading";
import Facebook from "./icons/Facebook";
import Instagram from "./icons/Instagram";
import Twitter from "./icons/Twitter";
import NewsLetter from "./NewsLetter";

export default {
  name: "FooterNav",
  components: {
    Heading,
    Facebook,
    Instagram,
    Twitter,
    NewsLetter,
  },
  data: () => ({
    questions: [
      {
        text: "Free consultation: (512) 813-0636",
        href: "tel:+15128130636",
      },
      {
        text: "Quick Contact Form",
        href: "#",
      },
      {
        text: "Email us",
        href: "#",
      },
    ],
    quickLinks: [
      {
        text: "Home",
        href: "/",
      },
      {
        text: "Flip cars like a pro",
        href: "/flip",
      },
      {
        text: "Hold ownership shares",
        href: "/hold",
      },
      {
        text: "How It Works",
        href: "/models",
      },
    ],

    company: [
      {
        text: "About us",
        href: "/about-us",
      },
      {
        text: "Investment News",
        href: "/investment-news",
      },
      {
        text: "Privacy Policy",
        href: "/privacy-policy",
      },
      {
        text: "Terms & Conditions",
        href: "/terms-conditions",
      },
    ],
    socialLinks: [
      {
        service: "Facebook",
        icon: "facebook",
        href: "https://www.facebook.com/BlueChipCar/",
      },
      {
        service: "Instagram",
        icon: "instagram",
        href: "https://www.instagram.com/bluechipcar/",
      },
      {
        service: "Twitter",
        icon: "twitter",
        href: "https://twitter.com/BlueChipCar",
      },
    ],
  }),
};
</script>
